import type { GetStaticProps, NextPage } from 'next';

import MarketingPage from '@/components/marketing/MarketingPage';
import getMarketingPage, { IMarketingPage } from '@/services/getMarketingPage';
import withRedirect from '@/utility/withRedirect';

const SLUG = 'coachnet-renters';

// Marketing page content rarely changes; 1-hour ISR avoids hitting Sanity
// on every render (was `getServerSideProps`).
const MARKETING_REVALIDATE_SECONDS = 86400;

interface IProps {
  page: IMarketingPage;
}

const Page: NextPage<IProps> = ({ page }) => <MarketingPage page={page} />;

export const getStaticProps: GetStaticProps = withRedirect(
  { destination: '/', permanent: false },
  async () => {
    const page = await getMarketingPage({ slug: SLUG });
    if (!page) {
      return { notFound: true, revalidate: MARKETING_REVALIDATE_SECONDS };
    }
    return { props: { page }, revalidate: MARKETING_REVALIDATE_SECONDS };
  },
);

export default Page;
